import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Ribbon from '../../svgs/Ribbon';

const FavoriteLink = styled.a.attrs({
  className: 'favorite-action',
})`
  background-color: #ffffff;
  bottom: -0.3rem;
  box-shadow: 0 1px 2px 0 hsla(0, 0%, 47%, 0.5);
  color: #878787;
  display: none;
  padding: 0.5rem;
  position: absolute;
  right: 0.5rem;
  z-index: 1;

  svg {
    display: block;
  }

  &:hover {
    background-color: #878787;

    path {
      fill: #ffffff;
    }
  }

  .favorites-index-page & {
    display: block;
  }

  .no-image & {
    float: right;
    margin: 0 0.5rem;
    position: static;
  }

  &.favorited {
    color: #1f1f1f;

    path {
      fill: #878787;
    }
  }
`;

const FavoritesRibbon = ({ favoritableId, favoritableSiteKey, title }) => (
  <FavoriteLink
    data-document-title={title}
    data-favoritable-id={favoritableId}
    data-origin-site={favoritableSiteKey}
    href={`#favorite-${favoritableId}`}
    title="Save to your favorites"
  >
    <Ribbon />
  </FavoriteLink>
);

FavoritesRibbon.propTypes = {
  favoritableId: PropTypes.string.isRequired,
  favoritableSiteKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default FavoritesRibbon;
